import ArchiveLayout from '@/layouts/ArchiveLayout';
import { ORGANIZATIONS_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Organizations',
  el: 'Φορείς',
};

const description: Record<Locale, string> = {
  en: 'Key organizations, institutions, and governing bodies.',
  el: 'Βασικοί φορείς, ιδρύματα και διοικητικά όργανα.',
};

const eyebrow: Record<Locale, string> = {
  en: 'ORGANIZATIONS',
  el: 'ΦΟΡΕΙΣ',
};

const emptyState: Record<Locale, string> = {
  en: 'No organizations available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμοι φορείς αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function OrganizationsArchive() {
  return (
    <ArchiveLayout
      pageKey="organizations"
      postType="organizations"
      query={ORGANIZATIONS_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
